import { Component, OnInit } from '@angular/core';
import { AgendaService } from 'src/app/services/agenda.service';

declare var Ext: any;

@Component({
  selector: 'app-agenda-header-list',
  templateUrl: './agenda-header-list.component.html',
  styleUrls: ['./agenda-header-list.component.scss']
})
export class AgendaHeaderListComponent implements OnInit {

  constructor(public agendaSrv: AgendaService) { }

  ngOnInit(): void {
  }

  showAllAgendas() {
    const agendaWindow = new Ext.CNAgendaWindow2();
    agendaWindow.show();
  }
}
